import { HStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { TransactionInfoProps } from "./type";

export const TransactionInfo = ({
  name,
  value,
  fontWeight = 500,
  valueColor
}: TransactionInfoProps) => {
  return (
    <HStack w="$full" justifyContent="space-between">
      <Text fontWeight={fontWeight} fontSize="$sm">
        {name}
      </Text>
      <Text color={valueColor}>{value}</Text>
    </HStack>
  );
};
